import { encryptRequest } from "./cryptoHelper";
import { apiPost } from "./apiClient";

const baseHeaders = { 'Content-Type': 'application/json' };

export const getSurveyDurationFromAPI = async (token, obj) => {
    const { encryptedData, encryptedAESKey } = encryptRequest(obj);

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        body: { encryptedData, encryptedAESKey },
    };

    return await apiPost('/survey-duration', requestInfo);
};
